export enum PartnerType {
    SE = 'Self Employed',
    IE = 'Individual Entrepreneur',
    LLC = 'Limited Liability Company',
}

export interface PartnerTypeTabsProps {
    partnerType: PartnerType;
    onChange: (type: PartnerType) => void;
}
